import {newSpecPage} from '@stencil/core/testing';
import {CompanyAvatar} from '../company-avatar';

const src = 'https://globalnews.ca/wp-content/uploads/2018/08/gettyimages-903462776.jpg?w=100';

it('renders company-avatar with an actual photo', async () => {
    const page = await newSpecPage({
        components: [CompanyAvatar],
        html: `
            <joy-company-avatar img-src="${src}"></joy-company-avatar>      
        `,
    });

    const img = page.root?.shadowRoot?.querySelector('img');
    expect(img).not.toBeNull();
    expect(img?.getAttribute('src')).toEqual(src);
});

it('renders small size company-avatar', async () => {
    const page = await newSpecPage({
        components: [CompanyAvatar],
        html: `<joy-company-avatar size="small"></joy-company-avatar>`,
    });

    const companyAvatar = page.root?.shadowRoot?.querySelector('.joy-company-avatar');
    expect(companyAvatar).toHaveClass('joy-company-avatar_small');
});

it('renders medium size company-avatar', async () => {
    const page = await newSpecPage({
        components: [CompanyAvatar],
        html: `<joy-company-avatar size="medium"></joy-company-avatar>`,
    });

    const companyAvatar = page.root?.shadowRoot?.querySelector('.joy-company-avatar');
    expect(companyAvatar).toHaveClass('joy-company-avatar_medium');
});

it('renders large size company-avatar', async () => {
    const page = await newSpecPage({
        components: [CompanyAvatar],
        html: `<joy-company-avatar size="large"></joy-company-avatar>`,
    });

    const companyAvatar = page.root?.shadowRoot?.querySelector('.joy-company-avatar');
    expect(companyAvatar).toHaveClass('joy-company-avatar_large');
});
